<template>
  <div class="oder">
    <user-info :userInfo="userInfo" :isShowFansBar="false" />
    <div class="content-bg">
      <h3>我的订单（{{ total }}）</h3>
      <van-list
        class="oder-bg"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        offset="30"
      >
        <div class="oder-item" v-for="item in recodes" :key="item.id">
          <div class="oder-text">
            <div class="oder-date">{{ item.created_at }}</div>
            <div class="oder-title">兑换商品：{{ item.gift_name }}</div>
          </div>
          <div class="oder-check" @click="oderDetailClick(item)">查看订单</div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import UserInfo from "./child/UserInfo";
import AttentItem from "./child/AttentItem";
import CollectItem from "./child/CollectItem";
import { getRedeemedGifts } from "network/profile";

export default {
  name: "Attent",
  components: {
    UserInfo,
    AttentItem,
    CollectItem,
  },
  data() {
    return {
      userInfo: {},
      currentIndex: 0,
      recodes: [],
      page: 0,
      loading: false,
      finished: false,
      total: 0,
    };
  },
  computed: {},
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  mounted() {},
  methods: {
    oderDetailClick(item) {
      this.$router.push({
        path: "/oderDetail",
        query: { params: { id: item.id, oderCount: this.total } },
      });
    },
    onLoad() {
      this.getRedeemedGifts();
    },
    getRedeemedGifts() {
      getRedeemedGifts(++this.page).then((res) => {
        this.recodes = this.recodes.concat(res.data);
        this.total = res.meta.total;
        if (res.data.length < 20) {
          this.finished = true;
        }
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.oder {
  background: #f5f5f5;
  min-height: 100vh;
}
.content-bg {
  margin: 20px 15px 0px 15px;
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;
}
.content-bg h3 {
  font-size: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e5e5e5;
}
.oder-bg {
  display: flex;
  flex-direction: column;
  align-content: space-around;
  min-height: 270px;
}
.oder-item {
  display: flex;
  padding: 15px 0;
  border-bottom: 1px solid #e5e5e5;
}
.oder-text {
  flex: 1;
}
.oder-date {
  font-size: 12px;
  color: #707070;
}
.oder-title {
  font-size: 14px;
  font-weight: 700;
}
.oder-check {
  align-self: flex-end;
  font-size: 13px;
  font-weight: 700;
  text-decoration: underline;
  color: var(--color-main);
}
</style>